import { render, staticRenderFns } from "./the-navigation.vue?vue&type=template&id=8c72def0&scoped=true"
import script from "./the-navigation.vue?vue&type=script&lang=js"
export * from "./the-navigation.vue?vue&type=script&lang=js"
import style0 from "./the-navigation.vue?vue&type=style&index=0&id=8c72def0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c72def0",
  null
  
)

export default component.exports